import { createContext, useContext } from 'react';

export const HashExceptionDetailsState = createContext();
export const HashExceptionDetailsDispatch = createContext();

export const useHashExceptionDetailsState = () => useContext(HashExceptionDetailsState);
export const useHashExceptionDetailsDispatch = () => useContext(HashExceptionDetailsDispatch);
